import React from "react";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export default function IconAction({ icon: Icon, label, destructive = false, confirmMessage, onClick, ...props }) {
  const handleClick = (event) => {
    if (confirmMessage && !window.confirm(confirmMessage)) return;
    onClick?.(event);
  };

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={`admin-icon-action ${destructive ? "admin-icon-action--destructive" : ""}`}
            aria-label={label}
            onClick={handleClick}
            {...props}
          >
            <Icon aria-hidden="true" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
